<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-payroll-bik-dialog-create
          v-if="$hasPermissionTo(['create benefit in kinds'])" 
          @created="loadBenefitInKinds"
        />
      </v-col>

      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Benefit In Kind's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in benefit in kind here"
          append-icon="search"
          label="Search Benefit In Kind"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>
  
    <v-data-table
      :headers="headers"
      :items="filteredBenefitInKinds"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.description="{ item }">
        <div
          v-if="item.description"
          v-html="item.description"
        />
        <div v-else>
          N/A
        </div>
      </template>

      <template v-slot:item.action="{ item }">
        <span v-if="statusFilter">
          <setup-payroll-bik-dialog-edit
            v-if="$hasPermissionTo(['update benefit in kinds'])"
            :benefit-in-kind="item" 
            @updated="refreshData"
          />
          <span class="mx-1" />

          <setup-payroll-bik-dialog-delete
            v-if="$hasPermissionTo(['delete benefit in kinds'])"
            :benefit-in-kind="item"
            @deleted="refreshData"
          />
        </span>
        <span v-else>
          <setup-payroll-bik-dialog-restore
            v-if="$hasPermissionTo(['restore benefit in kinds'])"
            :benefit-in-kind="item"
            @restored="refreshData"
          />
        </span>
      </template>
    </v-data-table> 
  </div>
</template>

<script>
  export default {
    components: {
      SetupPayrollBikDialogCreate: () => import('@/components/hris/setup/payroll/bik/DialogCreate'),
      SetupPayrollBikDialogEdit: () => import('@/components/hris/setup/payroll/bik/DialogEdit'),
      SetupPayrollBikDialogDelete: () => import('@/components/hris/setup/payroll/bik/DialogDelete'),
      SetupPayrollBikDialogRestore: () => import('@/components/hris/setup/payroll/bik/DialogRestore'),
    },
    data () {
      return {
        benefitInKinds: [],
        trashedBenefitInKinds: [],
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Description',
            align: 'left',
            value: 'description',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: true,
      }
    },
    computed: {
      filteredBenefitInKinds () {
        return this.statusFilter ? this.benefitInKinds : this.trashedBenefitInKinds
      },
    },
    created () {
      this.refreshData()
    },
    methods: {
      loadBenefitInKinds () {
        this.$api.benefitInKinds().list('?filter[type]=bik')
          .then(response => {
            this.benefitInKinds = response.data
            this.tableLoading = false
          })
      },
      loadTrashedBenefitInKinds () {
        this.$api.benefitInKinds().listTrashed('?filter[type]=bik')
          .then(response => {
            this.trashedBenefitInKinds = response.data
          })
      },
      refreshData () {
        this.loadBenefitInKinds()
        this.loadTrashedBenefitInKinds()
      },
    },
  }
</script>
